import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getBrandImage, getBrandLogo, getBrandName } from '../selectors';
import BrandLayout from '../components/BrandLayout';

const BrandLayoutContainer = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      brandName: getBrandName(state, ownProps.params.brandRoute),
      brandImage: getBrandImage(state, ownProps.params.brandRoute),
      brandLogo: getBrandLogo(state, ownProps.params.brandRoute),
    })
  )
)(BrandLayout);

export default BrandLayoutContainer;



// WEBPACK FOOTER //
// ./src/app/brands/containers/BrandLayout.js